export const categories = [
  { value: "baked_products", label: "Baked Products" },
  { value: "beverages", label: "Beverages" },
  { value: "cheese_eggs", label: "Cheese Milk and Eggs Products" },
  { value: "cooked_meals", label: "Cooked Meals" },
  { value: "fish_products", label: "Fish Products" },
  { value: "fruits_vegs", label: "Fruits and Vegetables" },
  { value: "herbs_spices", label: "Herbs and Spices" },
  { value: "meat_products", label: "Meat Products" },
  { value: "nuts_seeds_snacks", label: "Nuts Seeds and Snacks" },
  { value: "pasta_cereals", label: "Pasta and Breakfast Cereals" },
  { value: "restaurant_meals", label: "Restaurant Meals" },
  { value: "soups_sauces", label: "Soups, Sauces, fats and oil" },
  { value: "sweets_candy", label: "Sweets and Candy" },
  { value: "other", label: "Other" },
];

export const visibleFor = [
  // { value: "Only Myself", label: "Only Myself" },
  { value: "Coaches Of My Gym", label: "Coaches Of My Gym" },
  { value: "Members Of My Gym", label: "Members Of My Gym" },
  { value: "Everyone In My Gym", label: "Everyone In My Gym" },
];

export const weights = [
  { value: "g", label: "Gram" },
  { value: "ml", label: "ml" },
  { value: "g_ml", label: "Gram/ML" },
];

//   form info

export const basicInfo = [
  {
    type: "text",
    name: "name",
    label: "Name",
    text: "*",
    required: true,
  },
  {
    type: "text",
    name: "brand",
    label: "Brand",
    required: false,
  },
  {
    type: "select",
    label: "Category",
    name: "category_id",
    required: true,
    options: categories,
  },
  {
    type: "text",
    label: "Description",
    name: "description",
    required: false,
  },
  {
    type: "text",
    label: "Other Name",
    name: "other_name",
    required: false,
  },
  // {
  //   type: "select",
  //   name: "visible_for",
  //   label: "Visible For",
  //   required: true,
  //   options: visibleFor,
  // },
];
export const nutrientsInfo = [
  {
    index: 1,
    name: "total_nutrition",
    type: "number",
    label: "Total Nutrition (g)",
    required: true,
  },
  {
    index: 2,
    name: "kcal",
    type: "number",
    label: "Kcal",
    required: true,
  },

  {
    index: 3,
    name: "carbohydrates",
    type: "number",
    label: "Carbohydrates (g)",
    required: true,
  },
  {
    index: 4,
    name: "carbs_sugar",
    type: "number",
    label: "of which sugar(g)",
    required: false,
  },
  {
    index: 5,
    name: "fat",
    type: "number",
    label: "Total Fat (g)",
    required: true,
  },
  {
    index: 6,
    name: "carbs_saturated",
    type: "number",
    label: "Saturated (g)",
    required: false,
  },
  {
    index: 7,
    name: "protein",
    type: "number",
    label: "Protein (g)",
    required: true,
  },
  {
    index: 8,
    name: "kilojoules",
    type: "number",
    label: "Kilojoules (Kj)",
    required: false,
  },
  {
    index: 9,
    name: "fiber",
    type: "number",
    label: "Fiber (g)",
    required: false,
  },
  {
    index: 10,
    name: "calcium",
    type: "number",
    label: "Calcium (mg)",
    required: false,
  },
  {
    index: 11,
    name: "iron",
    type: "number",
    label: "Iron (mg)",
    required: false,
  },
  {
    index: 12,
    name: "magnesium",
    type: "number",
    label: "Magnesium (mg)",
    required: false,
  },
  {
    index: 13,
    name: "phosphorus",
    type: "number",
    label: "Phosphorus (mg)",
    required: false,
  },
  {
    index: 14,
    name: "potassium",
    type: "number",
    label: "Potassium (mg)",
    required: false,
  },
  {
    index: 15,
    name: "sodium",
    type: "number",
    label: "Sodium (mg)",
    required: false,
  },
  {
    index: 16,
    name: "zinc",
    type: "number",
    label: "Zinc (mg)",
    required: false,
  },
  {
    index: 17,
    name: "copper",
    type: "number",
    label: "Copper (mg)",
    required: false,
  },
  {
    index: 18,
    name: "selenium",
    type: "number",
    label: "Selenium (mg)",
    required: false,
  },
  {
    index: 19,
    name: "vitamin_c",
    type: "number",
    label: "Vitamin C (mg)",
    required: false,
  },
  {
    index: 20,
    name: "vitamin_b1",
    type: "number",
    label: "Vitamin B1 (mg)",
    required: false,
  },
  {
    index: 21,
    name: "vitamin_b2",
    type: "number",
    label: "Vitamin B2 (mg)",
    required: false,
  },
  {
    index: 22,
    name: "vitamin_b6",
    type: "number",
    label: "Vitamin B6 (mg)",
    required: false,
  },
  {
    index: 23,
    name: "folic_acid",
    type: "number",
    label: "Folic Acid (mcg)",
    required: false,
  },
  {
    index: 24,
    name: "vitamin_b12",
    type: "number",
    label: "Vitamin B12 (mcg)",
    required: false,
  },
  {
    index: 25,
    name: "vitamin_a",
    type: "number",
    label: "Vitamin A (mcg)",
    required: false,
  },
  {
    index: 26,
    name: "vitamin_e",
    type: "number",
    label: "Vitamin E (mg)",
    required: false,
  },
  {
    index: 27,
    name: "vitamin_d",
    type: "number",
    label: "Vitamin D (mcg)",
    required: false,
  },
  {
    index: 28,
    name: "fat_unsaturated",
    type: "number",
    label: "Fatty acid unsaturated (g)",
    required: false,
  },
  {
    index: 29,
    name: "cholesterol",
    type: "number",
    label: "Cholesterol (mg)",
    required: false,
  },
  {
    index: 30,
    name: "alcohol",
    type: "number",
    label: "Alcohol (g)",
    required: false,
  },
  {
    index: 31,
    name: "alchohol_mono",
    type: "number",
    label: "mono unsaturated (g)",
    required: false,
  },
  {
    index: 32,
    name: "alchohol_poly",
    type: "number",
    label: "poly unsaturated (g)",
    required: false,
  },
  {
    index: 33,
    name: "trans_fat",
    type: "number",
    label: "Trans fat (g)",
    required: false,
  },
];

export const initialValue = {
  // basic
  img_url: undefined,
  name: "",
  brand: "",
  category_id: undefined,
  description: "",
  other_name: "",
  visible_for: "Everyone In My Gym",
  
  // nutritions
  total_nutrition: undefined,
  kcal: undefined,
  protein: undefined,
  fat: undefined,
  carbohydrates: undefined,
  carbs_sugar: undefined,
  carbs_saturated: undefined,
  kilojoules: undefined,
  fiber: undefined,
  calcium: undefined,
  iron: undefined,
  magnesium: undefined,
  phosphorus: undefined,
  potassium: undefined,
  sodium: undefined,
  zinc: undefined,
  copper: undefined,
  selenium: undefined,
  vitamin_a: undefined,
  vitamin_b1: undefined,
  vitamin_b2: undefined,
  vitamin_b6: undefined,
  vitamin_b12: undefined,
  vitamin_c: undefined,
  vitamin_d: undefined,
  vitamin_e: undefined,
  folic_acid: undefined,
  fat_unsaturated: undefined,
  cholesterol: undefined,
  alcohol: undefined,
  alchohol_mono: undefined,
  alchohol_poly: undefined,
  trans_fat: undefined,
  weight: undefined,
  weight_unit_id: undefined,
};
